import { TCategorizedFiltersTree } from '@typings'

/** Cast categories tree to Antd Tree component format. */
export const prepareCategoriesTree = (data: TCategorizedFiltersTree = []): any =>
	data.map((categorizedFilter) => ({
		...categorizedFilter,
		key: String(categorizedFilter.id),
		children: prepareCategoriesTree(categorizedFilter.subCategorizedFilters),
	}))
